module.exports = __webpack_public_path__ + "static/media/brokenRocket.3d3302a9.svg";